import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function avatarShow(
    owner_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/avatar/${owner_id}/show${queryString}`
    );
}

export async function avatarCreate(
    owner_id: string,
    file: string
) {
    return await clientAxios.post(
        `admin/console/avatar/${owner_id}/create`,
        { file }
    );
}

export async function avatarPatch(
    owner_id: string,
    file: string
) {
    return await clientAxios.patch(
        `admin/console/avatar/${owner_id}/patch`,
        { file }
    );
}

export async function avatarUpdate(
    owner_id: string,
    file: string
) {
    return await clientAxios.put(
        `admin/console/avatar/${owner_id}/update`,
        { file }
    );
}

export async function avatarDelete(
    owner_id: string,
) {
    return await clientAxios.del(
        `admin/console/avatar/${owner_id}/delete`,
    );
}
